module.exports = __webpack_public_path__ + "img/Informaticien_06_AR.dcb774c8.jpg";